import { mapGetters } from "vuex";
import describeDocument from "@/data/describe/mixins/describeDocument";
import docLogFunctions from "@/document/log/mixins/docLogFunctions.js";
// import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
export default {
  data() {
    return {
      valid: true
    };
  },
  mixins: [
    describeDocument,
    docLogFunctions
    // createFirebase
  ],
  computed: {
    ...mapGetters([
      "getUser",
      "getPageInfo",
      "getUserDID",
      "getCompanyDID",
      "getFacilityDID"
    ])
  },
  methods: {
    generateDocumentLog(doc) {
      // console.log(">>> GENENRATE DOC. LOG");
      // console.log(doc);
      // USER LOG
      let tag = doc.basic.tag;
      let title = this.defineDocumentFromTag(tag).title;
      this.generateLog(tag, title, "was created.", doc);
      // this.createFirebaseDocumentLog(tag);
    },
    generateDocumentLogUpdate(doc) {
      // console.log("");
      // console.log(">>> GENERATE DOCUMENT LOG UPDATE <<<");
      // console.log(doc);
      // USER LOG
      let tag = doc.basic.tag;
      let pageTag = this.getPageInfo.tag;
      let title = this.defineDocumentFromTag(tag).title;
      this.generateLog(tag, title, "was updated.", doc);
      // the code below is to prevent app crashing
      // if changing the status of log item for
      // 1) user log 2) company log 3) facility log
      // eslint-disable-next-line
      if (
        pageTag !== "U1" &&
        pageTag !== "C1" &&
        pageTag !== "F1"
      ) {
        this.createFirebaseDocumentLog(tag);
      }
    },
    generateUserLog(doc, msg) {
      // console.log("");
      // console.log(">>> GENERATE USER LOG <<<");
      // console.log("TAG   : " + doc.basic.tag);
      // console.log("TITLE : " + doc.basic.title);
      // console.log("ID : " + doc.basic.id);
      // USER LOG
      let tag = doc.basic.tag;
      if (tag !== "O1") {
        let title = this.defineDocumentFromTag(tag).title;
        let udid = this.getUser.basic.did;
        let log = this.generateLog("U1", title, msg, doc);
        this.$store.dispatch("changeUserDID", udid);
        this.createFirebaseDocumentLog("U1", log);
      }
    },
    generateCompanyLog(doc, msg) {
      // console.log("");
      // console.log(">>> GENERATE COMPANY LOG <<<");
      // console.log("TAG    :" + doc.basic.tag);
      // console.log("TITLE  :" + doc.basic.title);
      // console.log("ID     :" + doc.basic.id);
      let tag = doc.basic.tag;
      if (
        tag === "B1" ||
        tag === "B3" ||
        tag === "B4" ||
        tag === "B6" ||
        tag === "E1" ||
        tag === "E2" ||
        tag === "E6" ||
        tag === "F1" ||
        tag === "L1" ||
        tag === "M2" ||
        tag === "Q1" ||
        tag === "S1" ||
        tag === "S6" ||
        tag === "W6"
      ) {
        let title = this.defineDocumentFromTag(tag).title;
        let cdid = this.getUser.pref.select.cdid;
        let log = this.generateLog("C1", title, msg, doc);
        this.$store.dispatch("changeCompanyDID", cdid);
        this.createFirebaseDocumentLog("C1", log);
      }
    },
    generateFacilityLog(doc, msg) {
      // console.log("");
      // console.log(">>> GENERATE FACILITY LOG <<<");
      // console.log("TAG   : " + doc.basic.tag);
      // console.log("TITLE : " + doc.basic.title);
      // console.log("ID : " + doc.basic.id);
      // console.log(doc);
      let tag = doc.basic.tag;
      let flow = doc.trans.flow;
      let status = flow[flow.length - 1].title;
      if (
        tag === "A1" ||
        tag === "M5" ||
        tag === "M7" ||
        // tag === "O1" || // O1 removed due to race condition D3 is ppulated and not O1
        tag === "W1" ||
        status === "Closed" ||
        status === "Cancelled"
      ) {
        let title = this.defineDocumentFromTag(tag).title;
        let fdid = this.getUser.pref.select.fdid;
        let log = this.generateLog("A1", title, msg, doc);
        // HELP
        // console.log("");
        // console.log("APPROVED FACILITY LOG GENERATED");
        // console.log("TAG   : " + doc.basic.tag);
        // console.log("TITLE : " + doc.basic.title);
        // console.log("ID :    " + doc.basic.id);
        // console.log("FDID :  " + fdid);
        // console.log("LOG :  ");
        // console.log(log);
        this.$store.dispatch("changeFacilityDID", fdid);
        this.createFirebaseDocumentLog("F1", log);
      }
    },
    generateAssetLog(doc, msg) {
      // console.log("");
      // console.log(">>> GENERATE ASSET LOG <<<");
      // console.log("DOC TAG     : " + doc.basic.tag);
      // console.log("DOC TITLE   : " + doc.basic.title);
      // console.log("DOC ID      : " + doc.basic.id);
      // console.log("ASSET TAG   : " + doc.link.aid);
      // console.log("ASSET TITLE : " + doc.link.at);
      // console.log("ASSET DID   : " + doc.link.adid);
      // console.log("DOCUMENT    : ");
      // console.log(doc);
      let tag = doc.basic.tag;
      let adid = doc.link.adid;
      // Update Store
      // NOTE W2 ASSET LOG covered under PLAN CALL
      if (adid !== null && adid !== null && adid !== "") {
        if (tag === "E2" || tag === "S6" || tag === "W1" || tag === "W2") {
          let title = this.defineDocumentFromTag(tag).title;
          let log = this.generateLog("A1", title, msg, doc);
          // HELP
          // console.log("");
          // console.log(">>> LOG CREATED <<<");
          // console.log("TITLE FROM TAG   : " + title);
          // console.log("MESSAGE          : " + msg);
          // console.log("LOG DETAIL       : ");
          // console.log(log);
          this.createFirebaseDocumentLog("A1", log);
        }
      }
    },
    generateActionAssigneeLog(doc, verb, udid) {
      // console.log("GENERATE USER ACTION ASSIGNEE LOG");
      // console.log(doc);
      // console.log(verb);
      // console.log(udid);
      // GENEATE USER LOG
      let title = "Action ";
      let msg = verb;
      let log = this.generateLog("U1", title, msg, doc);
      this.$store.dispatch("changeUserDID", udid);
      // this.$store.dispatch("changeUserDID", this.getRoleAssigneeDIDCurrent);
      this.createFirebaseDocumentLog("U1", log);
    },
    generateUserActionLogCreateResetAssignee(doc) {
      // console.log("GENERATE USER ACTION RESET ASSIGNEE LOG");
      // console.log(doc);
      // USER LOG
      let tag = doc.basic.tag;
      let title = this.defineDocumentFromTag(tag).title;
      let udid = this.getUser.basic.did;
      this.generateLog("U1", title, "was created.", doc);
      this.$store.dispatch("changeUserDID", udid);
      this.createFirebaseDocumentLog("U1");
    }
  }
};
